import { sumDecimalAmounts } from './decimal-sum'

type GroupInput = {
  previous_balance_local: string | null
  opening_balance_local: string | null
  accrued_balance_local: string | null
  trade_daily_accrual_amount: string | null
  value_date: string | null
  previous_value_date: string | null
  coupon_dates: string[]
  balance_status: string
}

const dates = (values: (string | null)[]) =>
  [...new Set(values.flatMap((value) => (value ?? '—').split(', ')))].sort().join(', ')

/** Retain unknown amounts and expose a common child state or PARTIAL on collapsed groups. */
export const aggregateBalanceRows = (rows: readonly GroupInput[]) => {
  const childStates = new Set(rows.map((row) => row.balance_status))
  const groupState = childStates.size === 1 ? rows[0].balance_status : 'PARTIAL'

  return {
    previous_balance_local: sumDecimalAmounts(rows.map((row) => row.previous_balance_local)),
    opening_balance_local: sumDecimalAmounts(rows.map((row) => row.opening_balance_local)),
    accrued_balance_local: sumDecimalAmounts(rows.map((row) => row.accrued_balance_local)),
    trade_daily_accrual_amount: sumDecimalAmounts(rows.map((row) => row.trade_daily_accrual_amount)),
    value_date: dates(rows.map((row) => row.value_date)),
    previous_value_date: dates(rows.map((row) => row.previous_value_date)),
    coupon_dates: [...new Set(rows.flatMap((row) => row.coupon_dates))].sort(),
    balance_status: groupState,
  }
}
